// =============================================
// src/pages/Services.tsx
// =============================================
import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  useTheme,
} from '@mui/material';
import LocalAirportIcon from '@mui/icons-material/LocalAirport';
import BusinessIcon from '@mui/icons-material/Business';
import CelebrationIcon from '@mui/icons-material/Celebration';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import NightlifeIcon from '@mui/icons-material/Nightlife';
import MapIcon from '@mui/icons-material/Map';

const services = [
  {
    icon: <LocalAirportIcon sx={{ fontSize: 48 }} />,
    title: "Airport Transfers",
    desc: "Seamless pickup and drop-off from any airport with meet-and-greet service.",
  },
  {
    icon: <BusinessIcon sx={{ fontSize: 48 }} />,
    title: "Corporate Travel",
    desc: "Executive transport for meetings, conferences, and business events.",
  },
  {
    icon: <CelebrationIcon sx={{ fontSize: 48 }} />,
    title: "Weddings & Events",
    desc: "Make your special day unforgettable with luxury transportation.",
  },
  {
    icon: <DirectionsCarIcon sx={{ fontSize: 48 }} />,
    title: "Hourly Charters",
    desc: "Flexible hourly service for any occasion or destination.",
  },
  {
    icon: <NightlifeIcon sx={{ fontSize: 48 }} />,
    title: "Night Out",
    desc: "Safe and stylish transportation for evenings in the city.",
  },
  {
    icon: <MapIcon sx={{ fontSize: 48 }} />,
    title: "Private Tours",
    desc: "Personalized sightseeing tours with professional chauffeurs.",
  },
];

const Services: React.FC = () => {
    const theme = useTheme();
  return (
    <>
      <Box sx={{ bgcolor: theme.palette.background.hero, minHeight: '100vh', color: 'white' }}>
        
        {/* Services Hero */}
        <Box
          sx={{
            height: { xs: '40vh', md: '50vh' },
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <Container maxWidth="lg">
            <Typography variant="h1" sx={{ color: 'text.primary', mb: 2 }}>
              Our Services
            </Typography>
            <Typography variant="h4" sx={{ color: 'text.secondary', maxWidth: 600 }}>
              Premium transportation tailored for every occasion
            </Typography>
          </Container>
        </Box>

        {/* Services Grid */}
        <Container maxWidth="lg" sx={{ 
                py: 10 
            }}>
          <Grid container spacing={4}>
            {services.map((service, index) => (
              <Grid key={index} size={{ xs: 12, sm: 6, md: 4 }}>
                <Card
                  sx={{
                    bgcolor: 'rgba(30, 41, 59, 0.6)',
                    backdropFilter: 'blur(12px)',
                    height: '100%',
                    transition: 'all 0.3s',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      bgcolor: 'rgba(30, 41, 59, 0.95)',
                    },
                  }}
                >
                  <CardContent sx={{ p: 5, textAlign: 'center' }}>
                    <Box sx={{ color: '#3b82f6', mb: 3 }}>
                      {service.icon}
                    </Box>
                    <Typography variant="h5" sx={{ mb: 2, color: 'white' }}>
                      {service.title}
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#cbd5e1', lineHeight: 1.7 }}>
                      {service.desc}
                    </Typography>
                    <Button
                      variant="outlined"
                      sx={{
                        mt: 4,
                        borderColor: '#3b82f6',
                        color: '#3b82f6',
                        '&:hover': { bgcolor: '#3b82f6', color: 'white' },
                      }}
                    >
                      Book Now
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Services;